import { render, staticRenderFns } from "./BigQueries.vue?vue&type=template&id=14b3cb24&"
import script from "./BigQueries.vue?vue&type=script&lang=ts&"
export * from "./BigQueries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports